import type { AtomModel, Setting } from '@/app/editor/iframe/atom/Atom.model';
import HELPER from '@/app/utils/HELPER';
import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';

/**
 * auto change setting when drag
 * thay đổi setting khi kéo mới stop: (Atom.ts)
 * hoặc kéo lại stop: (Dragable.ts)
 */
export class AutoRenderSetting {
  // private $activePanel = jQuery("#gfLeftSideBar #md-link .md-body.settings-panel");
  private $atom: JQuery;
  private data: AtomModel;
  private $gfFrame = jQuery('#gfFrame');
  /**
   * construction
   * @param $atom atom DOM
   * @param data atom data
   */
  constructor($atom: JQuery, data: AtomModel) {
    this.$atom = $atom;
    this.data = data;
  }
  /**
   * change setting when drag stop
   * @returns void
   */
  changeSetting(): Array<Setting> {
    const fields: Array<Setting> = this.data?.settings || {};
    const slugName: any = this.data?.slug || '';
    const moduleName: any = this.data?.name || '';
    const moduleId = this.data.id;
    switch (slugName) {
      case 'ultimate-sales-boost': {
        const $moduleParent = this.$atom.parent().closest('.module-wrap');
        const isInsideTheList = HELPER.isInsideTheList($moduleParent);
        const gType = this.$gfFrame.data('gfframe').getPageType();
        try {
          const allWIdget = {
            sticker: 'Sticker',
            message: 'Message',
            'get-it-by-timer': 'Get-it-by Timer',
            'buy-x-get-y': 'Buy X Get Y (BOGO)',
            'countdown-timer': 'Countdown Timer',
            'stock-inventory-number': 'Stock Inventory Number',
            'trust-badge': 'Trust Badge',
            'advanced-trust-badge': 'Advanced Trust Badge',
          };
          const widgetSticker = {
            sticker: 'Sticker',
          };
          if (fields && fields.length > 0) {
            const widgetIndex = fields.findIndex((x: any) => x.name == 'widget');
            if (widgetIndex && widgetIndex >= 0) {
              if (gType == 'template-collection') {
                // (Product List or Product Single) + Collection Page => 1 widget: Sticker
                fields[widgetIndex].options = widgetSticker;
              } else if (gType == 'template-product') {
                if (!isInsideTheList) {
                  // Product Sigle + Product Page => 8 widgets
                  fields[widgetIndex].options = allWIdget;
                } else {
                  // Product List + Product Page không cho kéo usb vào (Product List + Product Page)
                  HELPER.showNotify(
                    'Cannot put a ' + moduleName + ' into a Product List of Product Page',
                    'error',
                    5000,
                  );
                  fields[widgetIndex].options = {};
                }
              } else {
                // (Product List or Product Single) + Home Page => 1 widget: Sticker
                fields[widgetIndex].options = widgetSticker;
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      case 'ali-reviews': {
        const aliVersion = this.$atom.children('.module').attr('data-aliver');
        if (aliVersion == 'v6') {
          try {
            if (fields && fields.length > 0) {
              const fieldActions = [
                {
                  name: 'arv6picker',
                  action: (field: Setting, index?: number) => field && index && fields.splice(index, 1),
                },
                { name: 'v6widget', action: (field: Setting) => (field.visible = 'field-hide-all') },
                {
                  name: 'arv6SectionID',
                  action: (field: Setting) => {
                    field.visible = '';
                    field.caption = 'Section Id';
                    if (field.readonly) delete field.readonly;
                  },
                },
                {
                  name: 'arv6SectionName',
                  action: (field: Setting) => {
                    field.visible = '';
                    field.caption = 'Section Name';
                    if (field.readonly) delete field.readonly;
                  },
                },
              ];

              fieldActions.forEach(({ name, action }) => {
                const index = fields.findIndex((x: any) => x.name === name);
                if (index !== -1 && fields[index]) {
                  action(fields[index], index);
                }
              });
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
          }
        }
        break;
      }
      case 'lai-aliexpress-reviews': {
        let isNew = true;
        const $moduleParent = this.$atom.parent().closest('.module-wrap');
        const isInsideTheList = HELPER.isInsideTheList($moduleParent);
        if (!(window as any).gemDragging) {
          (window as any).gemDragging = {};
          (window as any).gemDragging.newLAI = [];
        }
        if (
          (window as any).gemDragging &&
          (window as any).gemDragging.newLAI &&
          (window as any).gemDragging.newLAI.length >= 0
        ) {
          const index = (window as any).gemDragging.newLAI.findIndex((x: any) => x.id == moduleId);
          if (index == -1) {
            (window as any).gemDragging.newLAI.push({ id: moduleId, status: 'new' });
            // const $module = this.$atom.children(".module");
            // const dataWidget = $module.attr("data-widget");
            // if (isInsideTheList || dataWidget == "list-rating") {
            //   (window as any).gemDragging.newLAI.push({ id: moduleId, status: "new" });
            // }
            // else {
            //   (window as any).gemDragging.newLAI.push({ id: moduleId, status: "update" });
            // }
          }
          (window as any).gemDragging.newLAI.forEach((dragItem: any) => {
            if (dragItem.id == moduleId && dragItem.status == 'update') {
              isNew = false;
            }
          });
        }
        if (isNew) {
          try {
            const widgetIndex = fields.findIndex((x: any) => x.name == 'widget');
            const pageType = this.$gfFrame.data('gfframe').getPageType();
            const subPageOption = {
              'product-rating': 'Star Ratings',
              'happy-page': 'Happy Customer Reviews',
            };
            const homePageOption = {
              'product-rating': 'Star Ratings',
              'home-section': 'Homepage Reviews',
            };
            const productPageOption = {
              'product-rating-anchorlink': 'Star Ratings',
              'product-section': 'Review Widget',
            };
            const $module = this.$atom.children('.module');
            if (fields && fields.length > 0 && widgetIndex > -1) {
              let defaultValue = fields[widgetIndex]['default_value'];
              const $parentProduct = this.$atom.closest('[data-label="Product"]');
              switch (pageType) {
                case 'template-page': {
                  if (isInsideTheList) {
                    fields[widgetIndex].options = {
                      'list-rating': 'Star Ratings in the List',
                    };
                    defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                  } else {
                    fields[widgetIndex].options = subPageOption;
                    if ($parentProduct.length > 0) {
                      defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                    } else {
                      defaultValue = fields[widgetIndex]['default_value'] = 'happy-page';
                    }
                  }
                  break;
                }
                case 'template-product': {
                  if (isInsideTheList) {
                    fields[widgetIndex].options = {
                      'list-rating': 'Star Ratings in the List',
                    };
                    defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                  } else {
                    fields[widgetIndex].options = productPageOption;
                    if ($parentProduct.length > 0) {
                      defaultValue = fields[widgetIndex]['default_value'] = 'product-rating-anchorlink';
                    } else {
                      defaultValue = fields[widgetIndex]['default_value'] = 'product-section';
                    }
                  }
                  break;
                }
                case 'template-index': {
                  if (isInsideTheList) {
                    fields[widgetIndex].options = {
                      'list-rating': 'Star Ratings in the List',
                    };
                    defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                  } else {
                    fields[widgetIndex].options = homePageOption;
                    if ($parentProduct.length > 0) {
                      defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                    } else {
                      defaultValue = fields[widgetIndex]['default_value'] = 'home-section';
                    }
                  }
                  break;
                }
                default: {
                  if (isInsideTheList) {
                    fields[widgetIndex].options = {
                      'list-rating': 'Star Ratings in the List',
                    };
                    defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                  } else {
                    fields[widgetIndex].options = {
                      'product-rating': 'Star Ratings',
                    };
                    defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                  }
                  break;
                }
              }
              const suffName = fields[widgetIndex].options[defaultValue];
              $module.attr('data-widget-name', suffName);
              $module.attr('data-widget', defaultValue);
              const $labelName = this.$atom.find('.gf_uncompile-module-name').find('span.widget');
              if (suffName) {
                $labelName.text(' - ' + suffName);
              }
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
          }
        }
        break;
      }
      case 'wiser':
      case 'wiser-personalized-recommendations':
      case 'wiser-personalized-recommendations-v2': {
        const isWiserV2 =
          fields.length > 0 && fields.findIndex((x: any) => x.id == 'wiserVersion' && x.default_value === 'V2') > -1;

        if (isWiserV2) {
          break;
        }

        const pageType = this.$gfFrame.data('gfframe').getPageType();
        // Vì trước đó element có 2 label
        // Wiser - Custom Pages & Wiser - Product & Collection Page
        // => cần thay đổi label theo label new
        const labelNameNew = 'Wiser - Personalized Recommendations';
        const label = 'Wiser';
        const $module = this.$atom.children('.module');
        // Option nằm trong tất cả các page
        const customPageOption = {
          recentview: 'Recently Viewed Products',
          newarrivals: 'New Arrivals',
          featured: 'Featured Products',
          topselling: 'Top Selling Products',
          trending: 'Trending Products',
          recent_related: 'Inspired By Your Browsing History',
        };
        // Option có thêm khi là Product Page
        const productOption = {
          related: 'Related Product',
          recommended: 'Recommended Products',
          alsobought: 'Frequently Bought Together',
        };
        const $labelName = this.$atom.find('.gf_uncompile-module-name');
        // Update label new
        $module.attr('data-label', labelNameNew);
        // Khi hover thì hiển thị label new
        this.$atom.children('.gf-tool-wrap').find('.t-handle .gf-tool-label').html(labelNameNew);
        try {
          if (fields && fields.length > 0) {
            let widgetIndex = fields.findIndex((x: any) => x.name == 'widget');
            // Kiểm tra nếu là setting trên element cũ thì sửa đổi lại
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (
              widgetGroupIndex > -1 &&
              fields[widgetGroupIndex]['items'] &&
              fields[widgetGroupIndex]['items'].length > 0
            ) {
              // lấy ra setting widget nằm trong group setting
              // Vì khi kiểm tra setting snippet của element Wiser trước đó bên trong group setting Choose Widget chỉ có 1 setting Widget
              //  => get items 0
              const widgetSetting: Setting = fields[widgetGroupIndex]['items'][0];
              // Chuyển setting group Choose Widget => setting Widget
              fields[widgetGroupIndex] = widgetSetting;
              // Hiện tại setting đã được thay đổi
              // Thay đổi caption của Widget
              widgetIndex = fields.findIndex((x: any) => x.name == 'widget');
              fields[widgetIndex]['caption'] = 'Choose Widget';
            }
            if (widgetIndex > -1) {
              let defaultValue: any = fields[widgetIndex]['default_value'];
              switch (pageType) {
                case 'template-product': {
                  const productPageOption = (fields[widgetIndex].options = { ...productOption, ...customPageOption });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fields[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fields[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                  break;
                }
                default: {
                  fields[widgetIndex].options = customPageOption;
                  if (Object.keys(customPageOption).indexOf(defaultValue) == -1) {
                    defaultValue = fields[widgetIndex]['default_value'] = Object.keys(customPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fields[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                  break;
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      // case rivyo:
      // case rivyo-reviews-display:
      case 'rivyo-product-reviews': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Rivyo';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          testimonials: 'Testimonials',
          allReviewsPage: 'All Reviews Page',
        };
        // Option có thêm khi là Product Page
        const productOption = {
          reviews: 'Reviews',
          badge: 'Star Badge',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');

              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (pageType == 'template-product' || isInsideTheProduct) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...productOption,
                    ...optionForAllPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }

        break;
      }
      // case opinew-featured:
      // case opinew-reviews:
      case 'opinew-product-reviews': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Opinew';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          carousel: 'Carousel',
          allReviews: 'All Reviews',
          allReviewsBadge: 'All Reviews badge',
        };
        // Option có thêm khi là Product Page
        const productOption = {
          reviews: 'Reviews',
          badge: 'Star Badge',
          badgeCollection: 'Star Badge in Collection',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (pageType == 'template-product' || isInsideTheProduct) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...productOption,
                    ...optionForAllPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      // case "Ryviu Featured":
      // case "Ryviu: Product Review App":
      case 'ryviu-product-reviews': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Ryviu';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          carousel: 'Carousel',
          masonry: 'Masonry',
        };
        // Option có thêm khi là Product Page
        const productOption = {
          reviews: 'Reviews',
          badge: 'Star Badge',
          badgeCollection: 'Star Badge in Collection',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (pageType == 'template-product' || isInsideTheProduct) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...productOption,
                    ...optionForAllPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      // case "Stamped":
      // case "Stamped Review":
      case 'stamped-product-reviews': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Stamped';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          carousel: 'Carousel',
          fullPage: 'Full Page',
          visualGallery: 'Visual Gallery',
          wallPhotos: 'Wall Photos',
          topRated: 'Top Rated',
          sideDrawer: 'Side Drawer',
          sideBadge: 'Site Badge',
          instagramFeed: 'Instagram Feed',
          checkoutComments: 'Checkout Comments',
        };
        // Option có thêm khi là Product Page
        const productOption = {
          reviews: 'Reviews',
          badge: 'Star Badge',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (pageType == 'template-product' || isInsideTheProduct) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...productOption,
                    ...optionForAllPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      case 'fera-reviews': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Fera Reviews';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          testimonialCarousel: 'Testimonial Carousel',
          allReviews: 'All Reviews',
          averageStoreRatingBadge: 'Average Store Rating Badge',
          // logoShowcaseBanner: 'Logo Showcase Banner',
          inStoreMedia: 'In Store Media',
          // collectionPageCounter: 'Collection Page Counter',
          // nonProductPageEventFeed: 'Non-product Page Event Feed',
          // eventPopups: 'Event Popups',
        };
        // Option có thêm khi là Product Page
        const insideProductOption = {
          productReviews: 'Product Reviews',
        };
        const insideProductPage = {
          averageRatingBadge: 'Average Rating Badge',
          productPageMedia: 'Product Page Media',
          // productPageCounter: 'Product Page Counter',
          // productPageEventFeed: 'Product Page Event Feed',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        const isInsideTheProductPage = pageType == 'template-product';
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (isInsideTheProductPage || isInsideTheProduct) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...insideProductOption,
                    ...optionForAllPage,
                    ...insideProductPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      case 'vitals': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Vitals';
        const $module = this.$atom.children('.module');
        const optionForAllPage = {
          goToWishlist: 'Go to Wishlist',
          paymentLogos: 'Payment Logos',
          recentlyViewed: 'Recently Viewed',
          shoppableInstagramFeed: 'Shoppable Instagram Feed',
          trustSealsAndBadges: 'Trust Seals and Badges',
        };
        const insideProduct = {
          addToWishlist: 'Add to Wishlist',
          productReviews: 'Product Reviews',
          productBundles: 'Product Bundles',
          volumeDiscounts: 'Volume Discounts',
          stockScarcity: 'Stock Scarcity',
        };
        const isInsideTheProductPage = pageType == 'template-product';
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (isInsideTheProductPage) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...insideProduct,
                    ...optionForAllPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else {
                  fieldsInGroup[widgetIndex].options = optionForAllPage;
                  if (Object.keys(optionForAllPage).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(optionForAllPage)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      case 'trustoo': {
        const pageType = this.$gfFrame.data('gfframe').getPageType();
        const label = 'Trustoo';
        const $module = this.$atom.children('.module');
        const insideProductModule = {
          starRating: 'Star Rating',
        };
        const insideProductPage = {
          reviews: 'Reviews',
        };
        const isInsideTheProduct =
          this.$atom.parent().closest('.module-wrap').closest('[data-label="Product"]').length > 0;
        const isInsideTheProductPage = pageType == 'template-product';
        try {
          if (fields && fields.length > 0) {
            // Lấy index Group Choose Widget
            const widgetGroupIndex = fields.findIndex((x: any) => x.caption == 'Choose Widget' && x.type == 'group');
            if (widgetGroupIndex > -1) {
              const fieldsInGroup = fields[widgetGroupIndex]['items'];
              const widgetIndex = fieldsInGroup.findIndex((x: any) => x.name == 'widget');
              const $labelName = this.$atom.find('.gf_uncompile-module-name');
              if (widgetIndex > -1) {
                let defaultValue: any = fieldsInGroup[widgetIndex]['default_value'];
                // Kiểm tra xem vị trí nằm của element có phải trong page Product hoạc child element Product
                if (isInsideTheProductPage) {
                  const productPageOption = (fieldsInGroup[widgetIndex].options = {
                    ...insideProductModule,
                    ...insideProductPage,
                  });
                  // Kiểm tra xem default value của element có nằm trong list option mới này hay ko
                  if (Object.keys(productPageOption).indexOf(defaultValue) == -1) {
                    // Nêu không -> Sẽ lấy value thứ 0 của productPageOption làm giá trị default
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(productPageOption)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                } else if (isInsideTheProduct) {
                  fieldsInGroup[widgetIndex].options = insideProductModule;
                  if (Object.keys(insideProductModule).indexOf(defaultValue) == -1) {
                    defaultValue = fieldsInGroup[widgetIndex]['default_value'] = Object.keys(insideProductModule)[0];
                  }
                  $module.attr('data-widget', defaultValue);
                  const suffName = fieldsInGroup[widgetIndex].options[defaultValue];
                  const conntentLbName = `${label}${
                    defaultValue ? '<span class="widget"> - ' + suffName + '</span>' : ''
                  }`;
                  $labelName.html(conntentLbName);
                }
              }
            }
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
    }
    this.setDataBkSettingByKey(JSON.stringify(fields));
    return fields;
  }

  /**
   * setDataBkSettingByKey
   */
  setDataBkSettingByKey(data: any, keyType = base._settings, atomType = 'module'): any {
    const moduleId = this.data.id;
    const keySetting = `${keyType}-${atomType}-${moduleId}`;
    (app as any).$store.commit('editor/SET_DATA_SETTINGS', {
      id: keySetting,
      value: data,
    });
    return false;
  }
}
